export default "__VITE_ASSET__DLfwxurY__"